 const correctSound = new Audio('/sounds/correct.wav');
 const wrongSound = new Audio('/sounds/wrong.mp3');
 const leaderboardSound = new Audio('/sounds/leaderboard.mp3');
 const top3Sound = new Audio('/sounds/top3.mp3');
 const gameoverSound = new Audio('/sounds/gameover.mp3');

// Optional but recommended
correctSound.preload = 'auto';
wrongSound.preload = 'auto';
leaderboardSound.preload = 'auto';
top3Sound.preload = 'auto';
gameoverSound.preload = 'auto';

export const preloadSounds = () => {
  // Preload sounds
  correctSound.load();
  wrongSound.load();
  leaderboardSound.load();
  top3Sound.load();
  gameoverSound.load();
}

preloadSounds();

export const sounds ={
    correct: () => correctSound.play(),
    wrong: () => wrongSound.play(),
    leaderboard: () => leaderboardSound.play(),
    top3: () => top3Sound.play(),
    gameover: () => gameoverSound.play(),
}

